import { ModeEnum as e } from "../core/models/model.js";
import { DatePicker as t } from "../ui/index.js";
import { UiContext as n } from "../ui/ui-provider.js";
import { ContextToggler as r } from "../ui/context-toggle.js";
import { WeekPresetMenu as i } from "../ui/week-preset-menu.js";
import { ad2bs as a } from "../calendar-carburettor/converter/index.js";
import { cn as o } from "../../../cn.js";
import { Icon as s } from "../../../icon/index.js";
import { cva as c } from "class-variance-authority";
import { Fragment as l, jsx as u, jsxs as d } from "react/jsx-runtime";
import { Case as f, Switch as p, When as m } from "react-if";
// src/design/forms/datepicker/composed/calendar-picker.tsx
var h = (e, t) => e && t ? a(e) : e, g = ({ isActive: e = !1, variant: t }) => /* @__PURE__ */ u(s, {
	name: e ? "CalendarDays" : "Calendar",
	strokeWidth: 2,
	className: o("w-4 h-4 shrink-0 transition-colors duration-normal", t === "filter" ? e ? "text-foreground" : "text-muted-foreground" : "text-foreground")
}), _ = ({ variant: e }) => /* @__PURE__ */ u(s, {
	name: "ChevronDown",
	className: o("w-4 h-4 transition-all duration-normal", e === "filter" ? "text-muted-foreground" : "text-foreground")
}), v = ({ onClick: e, variant: t }) => /* @__PURE__ */ u("button", {
	type: "button",
	onClick: e,
	"aria-label": "clear",
	className: o("flex shrink-0 items-center justify-center rounded-sm cursor-pointer transition-all duration-fast", t === "filter" ? "h-6 w-6 text-muted-foreground hover:bg-primary/8 hover:text-foreground" : "p-1 min-h-5 min-w-5 h-5 w-5 hover:bg-muted text-foreground"),
	children: /* @__PURE__ */ u(s, {
		name: "X",
		className: "w-4 h-4"
	})
}), y = c("flex border rounded-md transition-all cursor-pointer", {
	variants: { variant: {
		filter: [
			"h-8 max-h-8",
			"!border-border bg-filter-bg",
			"hover:bg-filter-hover hover:border-border",
			"focus-within:outline-hidden focus-within:border-ring focus-within:ring-3 focus-within:ring-ring/50",
			"font-medium text-xs text-primary"
		],
		input: ["max-h-8 bg-input-background border-input", "focus-within:outline-hidden focus-within:border-ring focus-within:ring-3 focus-within:ring-ring/50"]
	} },
	defaultVariants: { variant: "filter" }
}), b = c("flex gap-1 items-center pl-2 pr-1 border-r border-r-input transition-colors", {
	variants: {
		isActive: {
			true: "",
			false: ""
		},
		variant: {
			input: "text-foreground font-normal text-sm",
			filter: "text-foreground font-medium text-xs text-primary"
		}
	},
	defaultVariants: { variant: "filter" }
}), x = ({ variant: a, group: s, clearable: c }) => /* @__PURE__ */ u(t.Consumer, { children: ({ ctx: f, events: p }) => {
	let x = f.mode === e.RANGE, S = f.mode === e.WEEK, C = (e) => e === "start" && S ? "select week" : a === "input" ? "yyyy-mm-dd" : e === "start" ? x ? "start date" : "date" : "end date", w = f.isDisabled, T = a === "input", E = c ?? !T;
	return /* @__PURE__ */ u(n.Consumer, { children: ({ open: n, isOpen: c }) => {
		let D = !!f.startDate, O = !!f.endDate;
		return /* @__PURE__ */ d("div", {
			role: "group",
			...s,
			className: o(y({ variant: a }), { "cursor-not-allowed": w }),
			children: [
				/* @__PURE__ */ d("div", {
					role: x ? "group" : void 0,
					"aria-label": x ? "Start date" : void 0,
					className: o(b({
						isActive: D,
						variant: a
					}), { "pointer-events-none cursor-not-allowed": w }),
					onClick: () => {
						w || (n(), p.openCalendar("startDate"));
					},
					children: [
						/* @__PURE__ */ u(g, {
							isActive: D,
							variant: a || "filter"
						}),
						S ? /* @__PURE__ */ u("button", {
							type: "button",
							className: o("bg-transparent outline-hidden text-left truncate", {
								"rounded-r-none": f.showToggle,
								"text-xs": a === "filter",
								"text-sm": a === "input",
								"text-muted-foreground": !D
							}),
							children: D ? `${h(f.startDate, f.isNepali)} — ${h(f.endDate, f.isNepali)}` : C("start")
						}) : /* @__PURE__ */ u(t.Input, {
							className: o("bg-transparent outline-hidden", {
								"rounded-r-none": x || f.showToggle,
								"text-xs placeholder:text-xs placeholder:text-foreground": a === "filter",
								"text-sm placeholder:text-sm placeholder:text-muted-foreground": a === "input"
							}),
							variant: a,
							ref: f.startDateRef,
							value: f.startDate,
							placeholder: C("start"),
							onChange: (e) => {
								p.onDateChange(e);
							},
							onFocus: () => {
								if (!(c && f.currentDateSelection === "startDate")) return n(), p.openCalendar("startDate");
							}
						}),
						/* @__PURE__ */ u(m, {
							condition: E || !T,
							children: /* @__PURE__ */ u(l, { children: D && E ? /* @__PURE__ */ u(v, {
								variant: a || "filter",
								onClick: () => {
									let t = f.mode === e.RANGE ? {
										startDate: "",
										endDate: f.endDate || ""
									} : {
										startDate: "",
										endDate: ""
									};
									p.setStartAndEndDate(t);
								}
							}) : T ? null : /* @__PURE__ */ u(_, { variant: a || "filter" }) })
						})
					]
				}),
				/* @__PURE__ */ u(m, {
					condition: x,
					children: /* @__PURE__ */ d("div", {
						role: "group",
						"aria-label": "End date",
						className: o(b({
							isActive: O,
							variant: a
						})),
						onClick: () => {
							w || (n(), p.openCalendar("endDate"));
						},
						children: [
							/* @__PURE__ */ u(g, {
								isActive: O,
								variant: a || "filter"
							}),
							/* @__PURE__ */ u(t.Input, {
								className: o("bg-transparent outline-hidden", {
									"rounded-none": f.showToggle,
									"text-xs placeholder:text-xs placeholder:text-foreground": a === "filter",
									"text-sm placeholder:text-sm placeholder:text-muted-foreground": a === "input"
								}),
								variant: a,
								ref: f.endDateRef,
								value: f.endDate,
								placeholder: C("end"),
								onChange: (e) => {
									p.onDateChange(e);
								},
								onFocus: () => {
									if (!(c && f.currentDateSelection === "endDate")) return n(), p.openCalendar("endDate");
								}
							}),
							/* @__PURE__ */ u(m, {
								condition: E || !T,
								children: O && E ? /* @__PURE__ */ u(v, {
									variant: a || "filter",
									onClick: () => {
										let t = f.mode === e.RANGE ? {
											endDate: "",
											startDate: f.startDate || ""
										} : {
											endDate: "",
											startDate: ""
										};
										p.setStartAndEndDate(t);
									}
								}) : T ? null : /* @__PURE__ */ u(_, { variant: a || "filter" })
							})
						]
					})
				}),
				/* @__PURE__ */ u(i, {}),
				/* @__PURE__ */ u(m, {
					condition: f.showToggle,
					children: /* @__PURE__ */ u(r, {})
				})
			]
		});
	} });
} }), S = ({ variant: r = "filter", group: i, clearable: a }) => /* @__PURE__ */ u(n.Provider, { children: /* @__PURE__ */ u(t.CalendarPopover, {
	trigger: /* @__PURE__ */ u(x, {
		variant: r,
		group: i,
		clearable: a
	}),
	content: /* @__PURE__ */ d("div", {
		className: "w-60",
		children: [/* @__PURE__ */ u(n.Consumer, { children: ({ currentView: n, goToCalendarView: r, goToMonthView: i, goToYearView: a, close: o }) => /* @__PURE__ */ u("div", { children: /* @__PURE__ */ d(p, { children: [
			/* @__PURE__ */ u(f, {
				condition: n === "CALENDAR",
				children: /* @__PURE__ */ u(t.Consumer, { children: ({ ctx: n }) => /* @__PURE__ */ u(t.CalendarView, { children: /* @__PURE__ */ d("div", { children: [/* @__PURE__ */ u(t.CalendarView.Control, {
					onMonthClick: i,
					onYearClick: a
				}), /* @__PURE__ */ u(t.CalendarView.Grid, { onSelection: () => {
					n.closeOnSelect && (n.mode === e.SINGLE || n.mode === e.WEEK || n.currentDateSelection === "endDate") && o();
				} })] }) }) })
			}),
			/* @__PURE__ */ u(f, {
				condition: n === "MONTH",
				children: /* @__PURE__ */ u(t.MonthView, { children: /* @__PURE__ */ d("div", { children: [/* @__PURE__ */ u(t.MonthView.Control, { onYearClick: () => {
					r();
				} }), /* @__PURE__ */ u(t.MonthView.Grid, { onSelection: () => {
					r();
				} })] }) })
			}),
			/* @__PURE__ */ u(f, {
				condition: n === "YEAR",
				children: /* @__PURE__ */ u(t.YearView, { children: /* @__PURE__ */ d("div", { children: [/* @__PURE__ */ u(t.YearView.Control, { onYearMonthClick: () => {
					r();
				} }), /* @__PURE__ */ u(t.YearView.Grid, { onSelection: () => {
					i();
				} })] }) })
			})
		] }) }) }), /* @__PURE__ */ u(n.Consumer, { children: ({ close: n }) => /* @__PURE__ */ u(t.Consumer, { children: ({ ctx: r }) => /* @__PURE__ */ u("div", {
			className: "w-full flex items-center justify-center py-1 border-t border-border",
			children: /* @__PURE__ */ u(t.TodayButton, {
				onClick: () => {
					(r.mode === e.SINGLE || r.mode === e.WEEK || r.currentDateSelection === "endDate") && n();
				},
				children: /* @__PURE__ */ u("div", {
					className: "rounded-full transition-all duration-fast ease-linear hover:bg-info/5 text-xs text-info-text px-3 cursor-pointer py-1",
					children: "Today"
				})
			})
		}) }) })]
	})
}) }), C = () => /* @__PURE__ */ u(t, {
	mode: e.RANGE,
	disableDateBefore: "2025-11-04",
	disableDateAfter: "2026-01-04",
	disabledWeekDays: [2, 3],
	holidays: ["2025-12-25", "2025-12-26"],
	onChange: (e) => {
		console.log({ vals: e });
	},
	children: /* @__PURE__ */ u("div", {
		className: "space-y-8",
		children: /* @__PURE__ */ u("div", {
			className: "flex flex-col gap-2",
			children: /* @__PURE__ */ u(S, {})
		})
	})
});
export { C as CalendarPicker, S as CalendarPickerBody };

//# sourceMappingURL=calendar-picker.js.map